module.exports = __webpack_public_path__ + "img/24.8081f9f3.jpg";